<template>
  <div>
    <wc-page-title title='Dashboard'></wc-page-title>
    <v-container>
      <v-row>
      <!--   <v-col cols='12' md='4'>
          <wc-data-box
            title='Irrigation Summary'
            :loading='isLoading'
          >
            <wc-two-column-table :items='irrigationData'></wc-two-column-table>
          </wc-data-box>
        </v-col> -->
        <v-col cols='12' md='8'>
          <wc-data-box
            title='System Lookup'
          >
            <v-card-text>
              <v-text-field
                v-model='search'
                prepend-icon='mdi-magnify'
                label='Search'
                :loading='searching'
                :hint='searchStatus'
                persistent-hint
                append-icon='mdi-close'
                @click:append='clearSearch'
              >
              </v-text-field>
              <v-list>
                <v-list-item v-for='r in results' :key='r.id' @click='goToIrrigationDetail(r)'>
                  <v-list-item-content class='content'>
                    <v-list-item-title>
                      {{ r.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if='!searching && search.trim().length > 2 && results.length === 0'>
                  <v-list-item-content>
                    <v-list-item-subtitle class='grey--text'>
                      No systems found for "{{ search.trim() }}"
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import irrigationsAPI from '@/modules/irrigation/api/irrigations'
import _ from 'lodash'

export default {
  name: 'irrigation-dashboard',
  data: () => ({
    isLoading: false,
    irrigations: [],
    irrigationData: [],
    showSearch: false,
    searchStatus: '',
    searching: false,
    search: '',
    value: '',
    results: [],
    labels: [
      { id: 'ressy_systems', label: 'Residential Systems:' },
      { id: 'comm_systems', label: 'Commercial Systems:' },
      { id: 'wos_scheduled', label: 'Work Orders Scheduled for Today:' },
      { id: 'wos_completed', label: 'Work Orders Completed so far:' }
    ]
  }),
  mounted() {
    // this.getGeneralData()
  },
  watch: {
    search () {
      const length = this.search.trim().length
      if (length > 2) {
        this.executeSearch()
      } else if (length > 0) {
        const remaining = 3 - length
        this.searchStatus = `Type ${remaining} more letter${remaining > 1 ? 's' : ''} to search`
        this.executeSearch(true);
      } else {
        this.searchStatus = ''
        this.results = []
      }
    }
  },
  methods: {
    async getGeneralData () {
      this.isLoading = true
      const irrigationData = await irrigationsAPI.getIrrigationDashboard()
      Object.entries(irrigationData).forEach((one) => {
        this.irrigationData.push({ 'text': this.labels.find(a => a.id === one[0]).label, 'value': one[1] })
      })
      this.isLoading = false
    },
    openSearch () {
      this.showSearch = true
    },
    goToIrrigationDetail (value) {
      this.$router.push({ name: 'IrrigationOverview', params: { id: value.id }})
    },
    clearSearch () {
      this.search = ''
      this.results = []
    },
    executeSearch: _.debounce(function (exact) {
      this.searching = true
      if (!exact) {
        this.searchStatus = `Searching for "${this.search.trim()}"...`
      }
      this.searchAPI(exact)
    }, 300),
    async searchAPI (exact) {
      if (this.search === '') {
        this.results = []
        this.searchStatus = ''
      } else {
        this.results = await irrigationsAPI.irrigationSearch(this.search.trim(), exact)
        if (!exact) {
          this.searchStatus = ''
        }
      }
      this.searching = false
    }
  }
}
</script>